import React from 'react';

type RoleNames = {
  roleNames: string;
  dfn: string;
};

export function RoleNames({ roleNames, dfn }: RoleNames) {
  return (
    <p>
      <dfn className="invisible">{dfn}: </dfn>
      {roleNames}
    </p>
  );
}
